// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.slider-wrapper[data-v-34eb075b] {\n  position: relative;\n}\n.slide-info[data-v-34eb075b] {\n  width: 100%;\n  background: var(--white);\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
